
import {Vue, Component} from 'vue-property-decorator';
import {UserActivitiesDocument} from "@/interfaces/stats.interface";
import {UserActivities} from "@/axios/axios.freetrial";
import {UserSlack} from "@/axios/axios.apis";
import {SlackUsersDocument} from "@/interfaces/slack.interfaces";

@Component({})
export default class SAccFreetrial extends Vue {
  // Les props
  // Les propriétés
  public activities: UserActivitiesDocument[] = []
  public loading: boolean = false
  public headers = [
    {text: 'Firstname', value: 'firstname'},
    {text: 'Lastname', value: 'lastname'},
    {text: 'Email', value: 'email'},
    {text: 'Phone', value: 'phone'},
    {text: 'Slack', value: 'slackStatus'},
    {text: 'Password', value: 'password'},
    {text: 'Goals', value: 'goals'},
    {text: 'Cases', value: 'cases'},
    {text: 'Jobs', value: 'jobs'},
  ]
  public filter: string = ''
  private slack: SlackUsersDocument[] = []
  public footerProps = {
    showFirstLastPage: true,
    firstIcon: 'mdi-chevron-double-left',
    lastIcon: 'mdi-chevron-double-right',
    prevIcon: 'mdi-chevron-left',
    nextIcon: 'mdi-chevron-right'
  }

  // Les propriétés calculées
  // Les hooks
  public mounted() {
    this.loadActivities()
  }

  // Les méthodes surveillées
  // Les méthodes d'instance
  private async loadActivities() {
    this.loading = true
    const p = await Promise.all([UserActivities(), UserSlack()])

    const activities = p[0]
    this.slack = p[1]

    this.activities = activities.map(a => {
      if (!a.password) {
        a.password = 'Non'
        a.cases = '-'
        a.goals = '-'
        a.jobs = '-'
      } else {
        a.password = 'Oui'
      }
      this.mapSlack(a)
      return a
    })

    this.loading = false
  }

  private mapSlack(a: UserActivitiesDocument) {
    for (const s of this.slack) {
      if (s.email) {
        const regex = new RegExp('@gmail.com$')
        const isGmail = s.email && regex.test(s.email)
        const racineSlack = s.email.split('+')[0]
        if (s.email === a.email ||
            (isGmail && racineSlack === a.email.split('@')[0]) ||
            racineSlack === 'loic.griveau') {
          a.phone = s.phone
          a.slackStatus = s.accepted ? 'Accepté' : 'En attente'
        }
      }
    }
  }


  // Les méthodes statiques
}
